import {smartFetch, FETCH_POST_PARAMS} from "../utils";

export const FIELD_CHANGED = 'FIELD_CHANGED';
export const fieldChanged = (field, value, course) => ({type: FIELD_CHANGED, field, value, course});

export const FORM_VISIBLE = 'FORM_VISIBLE';
export const formVisible = (visible, course) => ({type: FORM_VISIBLE, visible, course});

export const FORM_SUCCESS = 'FORM_SUCCESS';
export const formSuccess = (success, course) => ({type: FORM_SUCCESS, success, course});

export const FORM_PROCESSING = 'FORM_PROCESSING';
export const formProcessing = (processing, course) => ({type: FORM_PROCESSING, processing, course});

export const FORM_ERROR = 'FORM_ERROR';
export const formError = (error, course) => ({type: FORM_ERROR, error, course});

export function createCourseApplication(data, course) {
    const url = course == 'custom' ? '/api/custom_courses/create.json' : '/api/custom_courses/create_bergen.json';

    return dispatch => {
        dispatch(formError('', course));
        dispatch(formProcessing(true, course));
        return smartFetch(url, FETCH_POST_PARAMS(data))
            .then(() => {
                dispatch(formProcessing(false, course));
                dispatch(formSuccess(true, course));
            })
            .catch(e => {
                console.error(e);
                dispatch(formProcessing(false, course));
                dispatch(formError('Не удалось отправить заявку. Пожалуйста, попробуйте еще раз или напишите нам в поддержку.', course));
            });
    }
}


// WEBPACK FOOTER //
// ./src/custom_course/actions.js